import { getAuthor } from '../utils/relations/author'

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

export const DOWNLOAD_DEFAULT = [
  {
    uuid: `959f28b0-d8b8-11eb-87ba-cd9fca99931e`,
    title: `Alcohol and sleep: help or hindrance?`,
    authorAlt: getAuthor(`neil-stanley`),
    portalScope: `Generic`,
    file: {
      url: `/downloads/alcohol-and-sleep-help-or-hindrance-download.pdf`,
    },
    image: { url: `/images/download-cover-alcohol-and-sleep.svg` },
  },
  {
    uuid: `e4177d10-8f92-117a-a0af-95e4e279b56f`,
    title: `Are sleeping pills effective?`,
    authorAlt: getAuthor(`joe-mcdonald`),
    portalScope: `Generic`,
    file: { url: `/downloads/are-sleeping-pills-effective-download.pdf` },
    image: {
      url: `/images/download-cover-how-effective-are-sleeping-pills.svg`,
    },
  },
  {
    uuid: `47f4e300-d8ba-11eb-9b6a-c5a099a6fe84`,
    title: `Can lack of sleep cause weight gain?`,
    authorAlt: getAuthor(`nicola-sunter`),
    portalScope: `Generic`,
    file: {
      url: `/downloads/can-lack-of-sleep-cause-weight-gain-download.pdf`,
    },
    image: {
      url: `/images/download-cover-can-lack-of-sleep-cause-weight-gain.svg`,
    },
  },
  {
    uuid: `47f4e300-d8ba-11eb-9b6a-c5a099a6fe84`,
    title: `Can lack of sleep cause weight gain?`,
    authorAlt: getAuthor(`nicola-sunter`),
    portalScope: `Generic`,
    file: {
      url: `/downloads/can-lack-of-sleep-cause-weight-gain-download.pdf`,
    },
    image: {
      url: `/images/download-cover-can-lack-of-sleep-cause-weight-gain.svg`,
    },
  },
  {
    uuid: `1abc6470-8f13-11ea-a0af-95e4e279b56f`,
    title: `Coping strategies for managing anxiety`,
    authorAlt: getAuthor(`raminder-mulla`),
    portalScope: `Generic`,
    file: {
      url: `/downloads/coping-strategies-and-advice-for-managing-anxiety-download.pdf`,
    },
    image: { url: `/images/cover-managing-anxiety.svg` },
  },
  {
    uuid: `92815550-8713-11eb-8382-ef09d42865eb`,
    title: `Discover your chronotype`,
    authorAlt: getAuthor(`white-et-al`),
    portalScope: `Generic`,
    file: { url: `/downloads/discover-your-chronotype-download.pdf` },
    image: { url: `/images/download-cover-discover-your-chronotype.svg` },
  },
  {
    uuid: `9e35af60-87de-11eb-88a8-4f53a394e43c`,
    title: `Dream sleep`,
    authorAlt: getAuthor(`neil-stanley`),
    portalScope: `Generic`,
    file: { url: `/downloads/dream-sleep-download.pdf` },
    image: { url: `/images/download-cover-dream-sleep.svg` },
  },
  {
    uuid: `8e80b920-4ddb-11ec-8f15-896883e30c57`,
    title: `Drowsy Driving: a dangerous journey`,
    authorAlt: getAuthor(`neil-stanley`),
    portalScope: `Generic`,
    file: { url: `/downloads/drowsy-driving-a-dangerous-journey-download.pdf` },
    image: { url: `/images/download-cover-drowsy-driving.svg` },
  },
  {
    uuid: `024719c0-8f00-11ea-a0af-95e4e27cb56f`,
    title: `Getting better sleep`,
    authorAlt: getAuthor(`neil-stanley`),
    portalScope: `Generic`,
    file: { url: `/downloads/getting-better-sleep-download.pdf` },
    image: { url: `/images/download-cover-getting-better-sleep.svg` },
  },
  {
    uuid: `24593b80-4de5-11ec-ae92-27e2b7c931f2`,
    title: `How does caffeine affect sleep?`,
    authorAlt: getAuthor(`kirstie-anderson`),
    portalScope: `Generic`,
    file: { url: `/downloads/how-does-caffeine-affect-sleep-download.pdf` },
    image: {
      url: `/images/download-cover-how-does-caffeine-affect-sleep.svg`,
    },
  },
  {
    uuid: `23999f90-4de6-11ec-851a-77a30ceed274`,
    title: `How does depression affect your sleep?`,
    authorAlt: getAuthor(`raminder-mulla`),
    portalScope: `Generic`,
    file: { url: `/downloads/how-does-depression-affect-your-sleep.pdf` },
    image: {
      url: `/images/download-cover-how-does-depression-affect-you-sleep.svg`,
    },
  },
  {
    uuid: `b603e1c0-4de5-11ec-a796-b3b955251221`,
    title: `How does nicotine affect sleep`,
    authorAlt: getAuthor(`raminder-mulla`),
    portalScope: `Generic`,
    file: { url: `/downloads/how-does-nicotine-affect-your-sleep.pdf` },
    image: {
      url: `/images/download-cover-how-does-nicotine-affect-sleep.svg`,
    },
  },
  {
    uuid: `6d7167e0-8f91-11ea-b367-f9db95dd4d75`,
    title: `How much sleep do you really need?`,
    authorAlt: getAuthor(`nicola-sunter`),
    portalScope: `Generic`,
    file: { url: `/downloads/how-much-sleep-do-you-really-need-download.pdf` },
    image: { url: `/images/cover-how-much-sleep-do-you-need.svg` },
  },
  {
    uuid: `c12cfb90-4ddb-11ec-a7d2-7b5a9928a224`,
    title: `How sleep changes with normal ageing`,
    authorAlt: getAuthor(`kirstie-anderson`),
    portalScope: `Generic`,
    file: {
      url: `/downloads/how-sleep-changes-with-normal-ageing-download.pdf`,
    },
    image: {
      url: `/images/download-cover-how-sleep-changes-with-normal-ageing.svg`,
    },
  },
  {
    uuid: `f37b34f0-4dda-11ec-8570-1fc85a06d213`,
    title: `REM Sleep Behaviour Disorder`,
    authorAlt: getAuthor(`kirstie-anderson`),
    portalScope: `Generic`,
    file: { url: `/downloads/rem-sleep-behaviour-disorder-download.pdf` },
    image: {
      url: `/images/download-cover-rem-sleep-behaviour-disorder.svg`,
    },
  },
  {
    uuid: `1cb65c10-8f93-11aa-a0af-95e4e271b56f`,
    title: `Sleep advice for parents`,
    authorAlt: getAuthor(`neil-stanley`),
    portalScope: `Generic`,
    file: { url: `/downloads/sleep-advice-for-parents-download.pdf` },
    image: { url: `/images/download-cover-sleep-advice-for-parents.svg` },
  },
  {
    uuid: `77f11800-7f93-11ea-a0af-9ae4e279ba6f`,
    title: `Sleep advice for shift workers`,
    authorAlt: getAuthor(`neil-stanley`),
    portalScope: `Generic`,
    file: { url: `/downloads/sleep-advice-for-shift-workers-download.pdf` },
    image: { url: `/images/cover-sleep-advice-for-shift-workers.svg` },
  },
  {
    uuid: `e688bf40-d8d4-11eb-82b6-7bec466e78a9`,
    title: `Sleep and immunity`,
    authorAlt: getAuthor(`nicola-sunter`),
    portalScope: `Generic`,
    file: { url: `/downloads/sleep-and-immunity-download.pdf` },
    image: { url: `/images/download-cover-sleep-and-immunity.svg` },
  },
  {
    uuid: `fc7fa5c0-d8bb-11eb-bd26-9d2da2392acd`,
    title: `Sleep in pregnancy`,
    authorAlt: getAuthor(`kirstie-anderson`),
    portalScope: `Generic`,
    file: { url: `/downloads/sleep-in-pregnancy-download.pdf` },
    image: { url: `/images/download-cover-sleep-in-pregnancy.svg` },
  },
  {
    uuid: `be0904a0-d8be-11eb-bd26-9d2da2392acd`,
    title: `Sleep tracking: the inside track`,
    authorAlt: getAuthor(`neil-stanley`),
    portalScope: `Generic`,
    file: { url: `/downloads/sleep-tracking-the-inside-track.pdf` },
    image: { url: `/images/download-cover-sleep-tracking.svg` },
  },
  {
    uuid: `d9d31f90-d8be-11eb-bd26-9d2da2392acd`,
    title: `The ideal bedroom setup`,
    authorAlt: getAuthor(`neil-stanley`),
    portalScope: `Generic`,
    file: { url: `/downloads/The-ideal-bedroom-setup-download.pdf` },
    image: { url: `/images/download-cover-the-ideal-bedroom-setup.svg` },
  },
  {
    uuid: `8849dd90-8714-11eb-8382-ef09d42865eb`,
    title: `The menopause and sleep disturbance`,
    authorAlt: getAuthor(`nicola-sunter`),
    portalScope: `Generic`,
    file: { url: `/downloads/menopause-and-sleep-disturbance-download.pdf` },
    image: {
      url: `/images/download-cover-menopause-and-sleep-disturbances.svg`,
    },
  },
  {
    uuid: `cbc146a1-8f9b-11ea-a01f-95e4e27bbb6f`,
    title: `What can go wrong with sleep?`,
    authorAlt: getAuthor(`neil-stanley`),
    portalScope: `Generic`,
    file: { url: `/downloads/what-can-go-wrong-with-sleep-download.pdf` },
    image: { url: `/images/cover-what-can-go-wrong-with-sleep.svg` },
  },
  {
    uuid: `880a52f0-4dda-11ec-8870-41b03cf6e414`,
    title: `What is narcolepsy?`,
    authorAlt: getAuthor(`kirstie-anderson`),
    portalScope: `Generic`,
    file: { url: `/downloads/what-is-narcolepsy-download.pdf` },
    image: { url: `/images/download-cover-narcolepsy.svg` },
  },
  {
    uuid: `19c6c8f0-4dda-11ec-b777-21d9b1a826ae`,
    title: `What is obstructive sleep apnoea?`,
    authorAlt: getAuthor(`kirstie-anderson`),
    portalScope: `Generic`,
    file: { url: `/downloads/what-is-obstructive-sleep-apnoea-download.pdf` },
    image: {
      url: `/images/download-cover-what-is-obstructive-sleep-apnoea.svg`,
    },
  },
  {
    uuid: `1d2f6190-8f90-11ea-a367-fadb95ed1875`,
    title: `What is sleep?`,
    authorAlt: getAuthor(`neil-stanley`),
    portalScope: `Generic`,
    file: { url: `/downloads/what-is-sleep-download.pdf` },
    image: { url: `/images/download-cover-what-is-sleep.svg` },
  },
  {
    uuid: `e8e9f8e0-4de5-11ec-b699-5f763d2372c4`,
    title: `What is sleep paralysis`,
    authorAlt: getAuthor(`kirstie-anderson`),
    portalScope: `Generic`,
    file: { url: `/downloads/what-is-sleep-paralysis-download.pdf` },
    image: { url: `/images/download-cover-what-is-sleep-paralysis.svg` },
  },
  {
    uuid: `f9b09fe0-d8be-11eb-bd26-9d2da2392acd`,
    title: `When to consult your doctor`,
    authorAlt: getAuthor(`kirstie-anderson`),
    portalScope: `Generic`,
    file: { url: `/downloads/when-to-consult-your-doctor-download.pdf` },
    image: { url: `/images/download-cover-when-to-consult-your-doctor.svg` },
  },
  {
    uuid: `53142340-8f9f-11ea-b3a7-f9db95cd4875`,
    title: `Why do we sleep?`,
    authorAlt: getAuthor(`neil-stanley`),
    portalScope: `Generic`,
    file: { url: `/downloads/why-do-we-sleep-download.pdf` },
    image: { url: `/images/cover-why-do-we-sleep.svg` },
  },
  {
    uuid: `33a3d660-4dd9-11ec-beb3-0b3dc1f66b99`,
    title: `Your bedtime routine`,
    authorAlt: getAuthor(`kirstie-anderson`),
    portalScope: `Generic`,
    file: { url: `/downloads/your-bedtime-routine-download.pdf` },
    image: { url: `/images/download-cover-your-bedtime-routine.svg` },
  },
]

export const DOWNLOAD_MAYBORN = [
  {
    uuid: `e4117d10-8f92-11ea-a0af-95e4e279b56f`,
    title: `Are sleeping pills effective?`,
    portalScope: `Mayborn`,
    authorAlt: getAuthor(`joe-mcdonald`),
    file: { url: `/downloads/are-sleeping-pills-effective-mayborn.pdf` },
    image: { url: `/images/cover-how-effective-are-sleeping-pills.svg` },
  },
  {
    uuid: `1abc6460-8f93-11ea-a0af-95e4e279b56f`,
    title: `Coping strategies for managing anxiety`,
    authorAlt: getAuthor(`raminder-mulla`),
    portalScope: `Mayborn`,
    file: {
      url: `/downloads/coping-strategies-and-advice-for-managing-anxiety-mayborn.pdf`,
    },
    image: { url: `/images/cover-managing-anxiety.svg` },
  },
  {
    uuid: `024719c0-8f93-11ea-a0af-95e4e279b56f`,
    title: `Getting better sleep`,
    authorAlt: getAuthor(`neil-stanley`),
    portalScope: `Mayborn`,
    file: { url: `/downloads/getting-better-sleep-mayborn.pdf` },
    image: { url: `/images/cover-how-can-i-sleep-better.svg` },
  },
  {
    uuid: `6d0167e0-8f91-11ea-b367-f9db95ed4875`,
    title: `How much sleep do you really need?`,
    authorAlt: getAuthor(`nicola-sunter`),
    portalScope: `Mayborn`,
    file: { url: `/downloads/how-much-sleep-do-you-really-need-mayborn.pdf` },
    image: { url: `/images/cover-how-much-sleep-do-you-need.svg` },
  },
  {
    uuid: `3cb65c10-8f93-11ea-a0af-95e4e279b56f`,
    title: `Sleep advice for parents`,
    authorAlt: getAuthor(`neil-stanley`),
    portalScope: `Mayborn`,
    file: { url: `/downloads/sleep-advice-for-parents-mayborn.pdf` },
    image: { url: `/images/cover-sleep-advice-for-parents.svg` },
  },
  {
    uuid: `77f1c800-8f93-11ea-a0af-95e4e279b56f`,
    title: `Sleep advice for shift workers`,
    authorAlt: getAuthor(`neil-stanley`),
    portalScope: `Mayborn`,
    file: { url: `/downloads/sleep-advice-for-shift-workers-mayborn.pdf` },
    image: { url: `/images/cover-sleep-advice-for-shift-workers.svg` },
  },
  {
    uuid: `cbc146a0-8f92-11ea-a0af-95e4e279b56f`,
    title: `What can go wrong with sleep?`,
    authorAlt: getAuthor(`neil-stanley`),
    portalScope: `Mayborn`,
    file: { url: `/downloads/what-can-go-wrong-with-sleep-mayborn.pdf` },
    image: { url: `/images/cover-what-can-go-wrong-with-sleep.svg` },
  },
  {
    uuid: `1d2f6790-8f90-11ea-b367-f9db95ed4875`,
    title: `What is sleep?`,
    authorAlt: getAuthor(`neil-stanley`),
    portalScope: `Mayborn`,
    file: { url: `/downloads/what-is-sleep-mayborn.pdf` },
    image: { url: `/images/cover-what-is-sleep.svg` },
  },
  {
    uuid: `53142340-8f91-11ea-b367-f9db95ed4875`,
    title: `Why do we sleep?`,
    authorAlt: getAuthor(`neil-stanley`),
    portalScope: `Mayborn`,
    file: { url: `/downloads/why-do-we-sleep-mayborn.pdf` },
    image: { url: `/images/cover-why-do-we-sleep.svg` },
  },
]
